import { ServiceDefinition } from '@pershing/pershing-core';

export class NXIRestServiceDefinition implements ServiceDefinition {
    private static instance: ServiceDefinition = null;

    uri: string = 'services/netxclient.rest-service';
    version: string = 'v1';
    family: string = 'netxinvestor';
    appName: string = 'rest-service';
    serviceName: string = 'app';
    mnemonic: string = 'nxc';

    static getInstance(): ServiceDefinition {
        if (!NXIRestServiceDefinition.instance) {
            NXIRestServiceDefinition.instance = new NXIRestServiceDefinition();
        }
        return NXIRestServiceDefinition.instance;
    }
    private constructor() {}
}
